// StatCard.tsx
import { TrendingDown, TrendingUp } from "lucide-react";
import React from "react";

interface Props {
  title: string;
  value: string | number;
  subtitle?: string | number;
  sinceLabel?: string;
  accent?: string; // tailwind color e.g. "bg-blue-500"
}

const StatCard: React.FC<Props> = ({ title, value, subtitle, sinceLabel = "since last week", accent = "bg-primary" }) => {
  return (
    <div className="rounded-xl bg-white/80 border p-4 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="text-left">
          <p className="text-sm text-primary">{title}</p>
          <p className="text-2xl font-semibold mt-1">{value}</p>
             <div className={`flex items-center gap-2 ${Number(subtitle) > 0 ? "text-green-800" : "text-red-800"}`}>
                {Number(subtitle) > 0 ? (
                    <>
                      {subtitle} %  
                      <TrendingUp size={24}/>
                    </>
                  ): (
                    <>
                      {subtitle} %  
                      <TrendingDown size={24}/>
                    </>
                  )}
                    {sinceLabel}
              </div>
        </div>
        <div className={`p-2 rounded-md ${accent} text-white hidden sm:block`}>
          {/* Placeholder icon circle */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" className="opacity-90">
            <circle cx="12" cy="12" r="10" fill="currentColor" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
